module.exports = __webpack_public_path__ + "static/media/wizualizacja-70.95c10dd1.png";